import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CardMask } from '../card-mask/card-mask';
import { TrackClickDirective } from '../../directives/track-click.directive';

export interface SummaryCardMobileData {
  borderColor: string;
  icon: string;
  iconBackgroundColor: string;
  title: string;
  subtitle?: string;
  items: {
    name: string;
    value: number;
  }[];
  buttonText?: string;
  buttonRoute?: string;
  tooltipText?: string;
  trackEvent?: string;
  trackCategory?: string;
  trackLabel?: string;
  comingSoon?: boolean;
}

@Component({
  selector: 'app-summary-card-mobile',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    CardMask,
    TrackClickDirective
  ],
  templateUrl: './summary-card-mobile.html',
  styleUrls: ['./summary-card-mobile.scss']
})
export class SummaryCardMobile {
  @Input() data!: SummaryCardMobileData;
  @Input() hasMask: boolean = false;
  @Output() openInfoModal = new EventEmitter<{title: string, message: string}>();

  constructor(private router: Router) { }

  getIconBackgroundWithOpacity(): string {
    return this.hexToRgba(this.data.iconBackgroundColor, 0.4);
  }

  private hexToRgba(hex: string, opacity: number): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  getButtonText(): string {
    return this.data.buttonText || 'Ver mais';
  }

  formatValue(value: number): string {
    return value === 0 ? '-' : value.toString();
  }

  onButtonClick(): void {
    if (this.data.buttonRoute) {
      this.router.navigate([this.data.buttonRoute]);
    }
  }

  onInfoButtonClick(event: Event): void {
    event.stopPropagation();
    // Emite o evento para o componente pai (dashboard)
    this.openInfoModal.emit({
      title: this.data.title,
      message: this.data.tooltipText || 'Informações adicionais'
    });
  }
}
